// extracted by mini-css-extract-plugin
module.exports = {"header":"SideHeader_header__1rTQD","logout":"SideHeader_logout__1nyfU","img":"SideHeader_img__3338q"};